var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.fetching ? _c('p', [_c('Loading')], 1) : [_c('div', {
    staticClass: "s-mb-6 s-space-y-3 text-center"
  }, [_c('Status', {
    class: _vm.statusClass,
    attrs: {
      "icon": _vm.statusIcon,
      "message": _vm.statusMessage
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.statusInfo)
    }
  })], 1), _vm.displayProduct ? _c('div', {
    staticClass: "s-space-y-8 s-mb-8"
  }, [_c('DescriptionList', {
    attrs: {
      "title": "商品名稱"
    }
  }, [_vm._v(_vm._s(_vm.display.productTitle))]), _c('DescriptionList', {
    attrs: {
      "title": "團購編號"
    }
  }, [_vm._v(_vm._s(_vm.display.groupbuyingNumber))])], 1) : _vm._e(), _c('a', {
    staticClass: "s-btn s-btn-primary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("確認")])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }